module.exports = __webpack_public_path__ + "assets/img/theX-header2.2740d4d4.png";